module.exports = __webpack_public_path__ + "assets/overlay-upper-teeth.5970dd42f94fe4b784ed1f5f49ccb8bf.png";